var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
import { colors, shadows } from "@wrstudios/theme";
export var Container = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.4rem;\n  height: 2.4rem;\n  font-size: 1.4rem;\n  font-weight: 700;\n  line-height: 1.4rem;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background-color: #4d5a6a;\n  color: ", ";\n  box-shadow: 0 0 0 0.4rem rgba(77, 90, 106, 0.3), ", ";\n  appearance: none;\n  cursor: pointer;\n"], ["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.4rem;\n  height: 2.4rem;\n  font-size: 1.4rem;\n  font-weight: 700;\n  line-height: 1.4rem;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background-color: #4d5a6a;\n  color: ", ";\n  box-shadow: 0 0 0 0.4rem rgba(77, 90, 106, 0.3), ", ";\n  appearance: none;\n  cursor: pointer;\n"])), colors.white, shadows.raised);
var templateObject_1;